enum Role {
  User       = "user",
  PowerUser  = "poweruser",
  Admin      = "admin"
}

type TPermission =
  | "view_users"
  | "manage_users"
  | "view_system"
  | "manage_systems"
  | "manage_species"
  | "simulate"
  | "simulated_advanced"
  | "import_layer"
  | "exportOrganix"
  | "exportLayer"
  | "delete_system_layer"
  | "edit_driverset"
  ;

/**
 * Mapping from role to permisions.
 */
const RolePermissions: Record<Role, TPermission[]> = {
  [Role.User]: [],
  [Role.PowerUser]: ["simulate", "delete_system_layer", "exportLayer"],
  [Role.Admin]:     ["view_users", "manage_users", "view_system", "manage_systems", "manage_species", "simulate", "simulated_advanced", "import_layer", "exportOrganix", "exportLayer", "delete_system_layer", "edit_driverset"],
};

/**
 * Check that the given set of roles are allowed this permission.
 */
function hasPermission(
  roles: Role[] | undefined,
  permission: TPermission
): boolean {
  if (!roles) return false;

  return roles.some(role => RolePermissions[role]?.includes(permission));
}

export { Role, TPermission, RolePermissions, hasPermission }
